import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "./context/AuthContext";
import { PrivateRoute } from "./components/PrivateRoute";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PatientsPage from "./pages/PatientsPage";
import PatientDetailPage from "./pages/PatientDetailPage";
import PurchaseOrdersPage from "./pages/PurchaseOrdersPage";
import PurchaseOrderDetailPage from "./pages/PurchaseOrderDetailPage";
import EditPurchaseOrderPage from "./pages/EditPurchaseOrderPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import EditInvoicePage from "./pages/EditInvoicePage";
import UtilitiesPage from "./pages/UtilitiesPage";
import PatientImport from "./components/admin/PatientImport";
import PatientSupplyHolds from "./components/admin/PatientSupplyHolds";
import PatientReconciliation from "./components/admin/PatientReconciliation";
import ActivePatientsPage from "./pages/ActivePatientsPage";
import ClientsPage from "./pages/ClientsPage";
import ClientDetailPage from "./pages/ClientDetailPage";
import GenerateResupplyPage from "./pages/GenerateResupplyPage";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path='/login' element={<LoginPage />} />
            <Route
              path='/dashboard'
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/patients'
              element={
                <PrivateRoute>
                  <PatientsPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/patients/:id'
              element={
                <PrivateRoute>
                  <PatientDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/purchase-orders'
              element={
                <PrivateRoute>
                  <PurchaseOrdersPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/purchase-orders/:id'
              element={
                <PrivateRoute>
                  <PurchaseOrderDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/purchase-orders/:id/edit'
              element={
                <PrivateRoute>
                  <EditPurchaseOrderPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/resupply/generate'
              element={
                <PrivateRoute>
                  <GenerateResupplyPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/invoices'
              element={
                <PrivateRoute>
                  <InvoiceListPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/invoices/:id/edit'
              element={
                <PrivateRoute>
                  <EditInvoicePage />
                </PrivateRoute>
              }
            />
            <Route
              path='/utilities'
              element={
                <PrivateRoute>
                  <UtilitiesPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin/patient-import'
              element={
                <PrivateRoute requiredRole={10}>
                  <PatientImport />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin/supply-holds'
              element={
                <PrivateRoute requiredRole={10}>
                  <PatientSupplyHolds />
                </PrivateRoute>
              }
            />
            <Route
              path='/admin/patient-reconciliation'
              element={
                <PrivateRoute requiredRole={10}>
                  <PatientReconciliation />
                </PrivateRoute>
              }
            />
            <Route
              path='/utilities/active-patients'
              element={
                <PrivateRoute>
                  <ActivePatientsPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/clients'
              element={
                <PrivateRoute>
                  <ClientsPage />
                </PrivateRoute>
              }
            />
            <Route
              path='/clients/:id'
              element={
                <PrivateRoute>
                  <ClientDetailPage />
                </PrivateRoute>
              }
            />
            <Route path='/' element={<Navigate to='/dashboard' replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
